module.exports = __webpack_public_path__ + "img/logo.d3b48d75.png";